import { fetchEventSource } from "@microsoft/fetch-event-source";
import type { SseEvent, SseSource } from "./types";

interface Opts {
    url: string;
    token: string;
    lastEventId: string | null;
}

export function fetchSource({ url, token, lastEventId }: Opts): SseSource {
    let eventCb: ((e: SseEvent) => void) | null = null;
    let errorCb: ((err: unknown) => void) | null = null;
    const ctrl = new AbortController();

    fetchEventSource(url, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
            ...(lastEventId ? { "Last-Event-ID": lastEventId } : {}),
            Accept: "text/event-stream",
        },
        signal: ctrl.signal,
        onmessage(msg) {
            eventCb?.({
                id: msg.id,
                event_type: msg.event,
                payload: msg.data ? JSON.parse(msg.data) : null,
            });
        },
        onerror(err) {
            errorCb?.(err);
            throw err;
        },
    });

    return {
        onEvent(h) {
            eventCb = h;
        },
        onError(h) {
            errorCb = h;
        },
        close() {
            ctrl.abort();
        },
    };
}
